import type { ReactNode } from 'react';
import { STANDARD_DELETE_CONFIRM_MESSAGE } from '@/constants/deleteConfirm';

export type StandardDeleteConfirmContentProps = {
  messageText?: string;
  extraContent?: ReactNode;
};

/**
 * Body for delete confirm dialogs (centered, red emphasis). Use inside `useAppModal().confirm({ content: ... })`.
 */
const StandardDeleteConfirmContent = ({
  messageText = STANDARD_DELETE_CONFIRM_MESSAGE,
  extraContent,
}: StandardDeleteConfirmContentProps) => (
  <div className="py-2 text-center">
    <p className="text-base leading-relaxed">
      <strong className="text-red-600">{messageText}</strong>
    </p>
    {extraContent ? <div className="mt-3 text-sm leading-relaxed">{extraContent}</div> : null}
  </div>
);

export default StandardDeleteConfirmContent;
